import React, { useState } from "react";
import { ReactComponent as EditIcon } from "../../../assets/svgs/editButton.svg";

const CustomerDetailForm = ({
  handleChange,
  basicInformation,
  showMoreInfo,
  userName,
  userId,
  toggleMoreInfo,
  handlePrimarySelection,
  OrganizationDetails,
  ContactDetails,
  onSave,
  saving,
  organizationDetails,
  contactDetails,
  handleOrgChange,
  handleOrgFileSelect,
  handleBillingChange,
  handleIdentityFileSelect,
  handleBillingPassportFileSelect,
  onBillingEmailVerified,
}) => {
  const [enableEdit, setEnableEdit] = useState(false);
  const initial = userName?.trim().charAt(0).toUpperCase() || "";
console.log(userId, "userId in form");
const customerId = userId || "N/A";
  return (
    <div>
      <div className="bg-white rounded-lg ">
        {/* Header Section */}
        <div className="flex justify-between items-start mb-2.5">
          <div className="flex gap-4 px-3">
            <div className="w-10 h-10 rounded-md border border-[#06513D] flex items-center justify-center text-[#06513D] text-xl font-normal shadow-[0px_2px_6.2px_0px_#06513D85]">
              {initial}
            </div>

            <div className="flex flex-col justify-center">
              <div className="font-bold text-xl leading-tight uppercase text-[#06513D]">
                {userName}
              </div>
              <div className="font-normal text-[15px] leading-tight text-gray-600 mt-1">
                {customerId}
              </div>
            </div>
          </div>

          {!enableEdit && (
            <div className="px-4 pt-2">
              <button
                onClick={() => setEnableEdit(true)}
                className="px-4 py-2 rounded-lg bg-[#E6EDEB] border border-solid border-[#06513D] flex items-center justify-center shadow-md cursor-pointer hover:bg-[#F8F8F8] transition-colors"
              >
                <EditIcon />
                <span className="pl-2 text-lg font-light text-[#06513D]">
                  Edit
                </span>
              </button>
            </div>
          )}
        </div>

        {/* Basic Information */}
        <div className="px-10 mb-6">
          <h4 className="text-xl font-semibold text-[#06513D] mb-4">
            Basic Information
          </h4>

          <div className="grid grid-cols-2 gap-8">
            {/* Left Column */}
            <div className="space-y-3">
              <div>
                <label className="block font-semibold text-gray-500 mb-1">
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={basicInformation.name}
                  onChange={handleChange}
                  className="w-full p-2 border-b focus:outline-none focus:border-[#06513D] disabled:bg-transparent"
                  disabled={!enableEdit}
                />
              </div>

              <div>
                <label className="block font-semibold text-gray-500 mb-1">
                  Location
                </label>
                <input
                  type="text"
                  name="location"
                  value={basicInformation.location}
                  onChange={handleChange}
                  className="w-full p-2 border-b focus:outline-none focus:border-[#06513D] disabled:bg-transparent"
                  disabled={!enableEdit}
                />
              </div>
            </div>

            {/* Right Column */}
            <div className="space-y-3">
              {/* <div>
                <label className="block font-semibold text-gray-500 mb-1">
                  Username
                </label>
                <input
                  type="text"
                  name="username"
                  value={basicInformation.username}
                  onChange={handleChange}
                  className="w-full p-2 border-b focus:outline-none focus:border-[#06513D] disabled:bg-transparent"
                  disabled={!enableEdit}
                />
              </div> */}

              <div>
                <label className="block font-semibold text-gray-500 mb-1">
                  Username / Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={basicInformation.email}
                  onChange={handleChange}
                  className="w-full p-2 border-b focus:outline-none focus:border-[#06513D] disabled:bg-transparent"
                  disabled={!enableEdit}
                  placeholder="Login email"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Contact Details */}
        <div className="px-10 mb-4">
          <h4 className="text-xl font-semibold text-[#06513D] mb-4">
            Contact Detail
          </h4>

          {/* Contact Details 1 */}
          <div className="flex items-end gap-6 mb-6">
            <div className="flex-1">
              <label className="block font-semibold text-gray-500 mb-2">
                1. Contact Number
              </label>
              <input
                type="text"
                name="contactNumber_1"
                value={basicInformation.contactNumber_1}
                onChange={handleChange}
                className="w-full p-2 border-b focus:outline-none focus:border-[#06513D] disabled:bg-transparent"
                disabled={!enableEdit}
              />
            </div>

            <div className="flex-1">
              <label className="block font-semibold text-gray-500 mb-2">
                Email ID
              </label>
              <input
                type="text"
                name="emailId_1"
                value={basicInformation.emailId_1}
                onChange={handleChange}
                className="w-full p-2 border-b focus:outline-none focus:border-[#06513D] disabled:bg-transparent"
                disabled={!enableEdit}
              />
            </div>

            <div className="flex items-center pb-2">
              <input
                type="radio"
                id="primary_1"
                name="primaryContact"
                onChange={() => handlePrimarySelection("contact_1")}
                checked={
                  basicInformation.primaryContactNumber ===
                  basicInformation.contactNumber_1
                }
                disabled={!enableEdit}
                className="cursor-pointer"
              />
              <label
                htmlFor="primary_1"
                className="ml-2 text-gray-500 whitespace-nowrap cursor-pointer"
              >
                Make it Primary
              </label>
            </div>
          </div>

          {/* Contact Details 2 */}
          <div className="flex items-end gap-6 mb-6">
            <div className="flex-1">
              <label className="block font-semibold text-gray-500 mb-2">
                2. Contact Number
              </label>
              <input
                type="text"
                name="contactNumber_2"
                value={basicInformation.contactNumber_2}
                onChange={handleChange}
                className="w-full p-2 border-b focus:outline-none focus:border-[#06513D] disabled:bg-transparent"
                disabled={!enableEdit}
              />
            </div>

            <div className="flex-1">
              <label className="block font-semibold text-gray-500 mb-2">
                Email ID
              </label>
              <input
                type="text"
                name="emailId_2"
                value={basicInformation.emailId_2}
                onChange={handleChange}
                className="w-full p-2 border-b focus:outline-none focus:border-[#06513D] disabled:bg-transparent"
                disabled={!enableEdit}
              />
            </div>

            <div className="flex items-center pb-2">
              <input
                type="radio"
                id="primary_2"
                name="primaryContact"
                onChange={() => handlePrimarySelection("contact_2")}
                checked={
                  basicInformation.primaryContactNumber ===
                  basicInformation.contactNumber_2
                }
                disabled={!enableEdit}
                className="cursor-pointer"
              />
              <label
                htmlFor="primary_2"
                className="ml-2 text-gray-500 whitespace-nowrap cursor-pointer"
              >
                Make it Primary
              </label>
            </div>
          </div>

          {/* Additional Actions */}
          {enableEdit && (
            <div className="space-y-3 mb-6">
              {/* <button className="w-full bg-[#def5fa] text-[#06513D] rounded-md py-2 font-semibold hover:bg-[#c5ebf3] transition-colors">
                + Add Contact Details
              </button> */}
              <button
                onClick={onSave}
                disabled={saving}
                className="w-full bg-[#06513D] text-white rounded-md py-2 font-semibold hover:bg-[#054d39] transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {saving ? "Saving..." : "Save"}
              </button>
            </div>
          )}
        </div>

        {showMoreInfo && (
          <div className="mt-6 px-10">
            <div className="mb-6">
              <label className="block font-semibold text-gray-500 mb-2">
                Description
              </label>
              <textarea
                name="description"
                value={basicInformation.description}
                onChange={handleChange}
                disabled={!enableEdit}
                className="w-full h-24 p-3 border rounded-lg border-gray-300 focus:outline-none focus:border-[#06513D] disabled:bg-gray-50"
              />
            </div>

            {/* Additional Components */}
            <div className="">
              <OrganizationDetails
                isEditing={enableEdit}
                organizationDetails={organizationDetails}
                contactDetails={contactDetails}
                handleOrgChange={handleOrgChange}
                handleBillingChange={handleBillingChange}
                handleOrgFileSelect={handleOrgFileSelect}
              />
              <ContactDetails
                isEditing={enableEdit}
                contactDetails={contactDetails}
                handleBillingChange={handleBillingChange}
                handleBillingPassportFileSelect={handleBillingPassportFileSelect}
                onBillingEmailVerified={onBillingEmailVerified}
              />
            </div>

            {/* Additional Actions */}
            {enableEdit && (
              <div className="flex gap-4 my-6">
                <button
                  type="button"
                  onClick={() => setEnableEdit(false)}
                  className="flex-1 rounded-md py-2 font-semibold border text-gray-600 hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={onSave}
                  disabled={saving}
                  className="flex-1 bg-[#06513D] text-white rounded-md py-2 font-semibold hover:bg-[#054d39] transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {saving ? "Saving..." : "Save All"}
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Toggle More Info Button */}
      <button
        onClick={toggleMoreInfo}
        className="w-[90%] border border-[#06513D] bg-[#E6EDEB] text-[#06513D] rounded-md py-2 font-semibold hover:bg-[#F8F8F8] transition-colors mx-auto block mt-2 mb-4"
      >
        {showMoreInfo ? "Close" : "+ More Info"}
      </button>
    </div>
  );
};

export default CustomerDetailForm;